import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, createRef } from 'intact-vue-next';
import template from './index.vdt';
import { useStyle } from './useStyle';
import { useConfigContext } from '../config';
var typeDefs = {
  top: Number,
  bottom: Number,
  exclude: Function,
  shouldFix: Function
};
export var Affix = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Affix, _Component);
  function Affix() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.style = useStyle(_this.elementRef);
    _this.config = useConfigContext();
    return _this;
  }
  return Affix;
}(Component);
Affix.template = template;
Affix.typeDefs = typeDefs;